import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import SettingProvider from '@/components/SettingProvider';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/SettingProvider',
      name: 'SettingProvider',
      component: SettingProvider,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js